import React, { useEffect, useState } from "react";
import "../../Styles/yellowcalf.css/Accountant.css";
import { FaUser, FaWallet } from "react-icons/fa";
import {
  simpleGetCallWithErrorResponse,
  simplePostCall,
} from "../../api/ApiServices";
import ApiConfig from "../../api/ApiConfig";
import ScaleLoader from "react-spinners/ScaleLoader";

function Accountant() {
  const [selectedStudent, setSelectedStudent] = useState("");
  const [AccountantData, setAccountantData] = useState({});
  const [AccountantDataCount, setAccountantDataCount] = useState({});
  console.log("AccountantData", AccountantData);

  const [AccountantStudentList, setAccountantStudentList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isStudentLoading, setIsStudentLoading] = useState(false);

  const [selectedStudentId, setSelectedStudentId] = useState("");
    const customer_currency = (localStorage.getItem("customer_currency") || "").replace(/"/g, "");

  const handleClear = () => {
    setSelectedStudent("");
  };
  useEffect(() => {
    loadDataSocket();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const loadDataSocket = async () => {
    setIsLoading(true); // Start loading

    // 1. Get credentials from localStorage (instead of hardcoding)
    const customer_id = localStorage.getItem("customer_id");
    const api_key = localStorage.getItem("api_key");

    const requestBody = {
      customer_id: Number(customer_id) || 1005, // Fallback to 1005 if not found
      api_key: api_key || "b9359f494e77b6589ce12dd62518c585",
    };

    try {
      // 2. Fix: Pass URL and Body as separate arguments
      // Use the variable from ApiConfig directly
      const response = await simplePostCall(
        ApiConfig.dashboradlist,
        JSON.stringify(requestBody),
      );

      console.log("Response Received:", response);

      // 3. Logic Fix: Only set data if it exists

      if (response?.result) {
        setAccountantDataCount(response); // Set the actual data
        const list = response.studentList || [];
        setAccountantStudentList(list);
        // Auto-load first student by default
        if (list.length > 0) {
          const firstId = list[0].student_id;
          setSelectedStudentId(firstId);
          await loadDataStudent(firstId);
        }
      } else {
        // setAccountantData([]); // Clear data if empty or error
      }
    } catch (error) {
      console.error("Error loading orders:", error);
      // setAccountantData([]); // Ensure state is consistent on error
    } finally {
      setIsLoading(false); // Stop loading regardless of outcome
    }
  };

  const handleSelect = (e) => {
    const studentId = e.target.value;
    setSelectedStudentId(studentId);
    if (studentId) {
      loadDataStudent(studentId);
    }
  };

  const loadDataStudent = async (id) => {
    setIsStudentLoading(true);
    const customer_id = localStorage.getItem("customer_id");
    const api_key = localStorage.getItem("api_key");

    const requestBody = {
      customer_id: Number(customer_id),
      api_key: api_key,
      student_id: id, // Use the ID passed from the select
    };

    try {
      const response = await simplePostCall(
        ApiConfig.dashboradStudentList,
        JSON.stringify(requestBody),
      );

      // Based on your response example, it returns an object with { result: true, student_data: [...] }
      if (response?.result) {
        setAccountantData(response);
      } else {
        setAccountantData(null);
      }
    } catch (error) {
      console.error("Error loading student:", error);
      setAccountantData(null);
    } finally {
      setIsStudentLoading(false);
    }
  };
  
  // Format numbers with thousand separators (1,234,567)
  const formatNumber = (val) => {
    const num = parseFloat(val);
    if (isNaN(num)) return val ?? 0;
    return num.toLocaleString("en-US", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    });
  };

  return (
    <div className="acc-main-content">
      {isLoading ? (
        <div className="acc-loader-wrap">
          <ScaleLoader color="#F4BB44" />
          <p className="text-muted mt-3">Loading dashboard, please wait...</p>
        </div>
      ) : (
        <div className="acc-container">
          {/* Top Stat Tiles */}
          <div className="acc-stat-row">
            <div className="acc-stat-tile acc-tile-teal">
              <p className="acc-stat-tile-label">Todays Fee Collection</p>
              <h3 className="acc-stat-tile-value">
                <span className="acc-stat-tile-currency">{customer_currency}</span>
                {formatNumber(AccountantDataCount.gettodayFee || 0)}
              </h3>
            </div>

            <div className="acc-stat-tile acc-tile-amber">
              <p className="acc-stat-tile-label">Todays Busfare Collections</p>
              <h3 className="acc-stat-tile-value">
                <span className="acc-stat-tile-currency">{customer_currency}</span>
                {formatNumber(AccountantDataCount.getbusfaredata || 0)}
              </h3>
            </div>

            <div className="acc-stat-tile acc-tile-blue">
              <p className="acc-stat-tile-label">Todays Wallet Recharge</p>
              <h3 className="acc-stat-tile-value">
                <span className="acc-stat-tile-currency">{customer_currency}</span>
                {formatNumber(AccountantDataCount.getWallettoday || 0)}
              </h3>
            </div>

            <div className="acc-stat-tile acc-tile-purple">
              <p className="acc-stat-tile-label">Todays Final Due &amp; Registration Collection</p>
              <h3 className="acc-stat-tile-value">
                <span className="acc-stat-tile-currency">{customer_currency}</span>
                {formatNumber(AccountantDataCount.calculateTotalDuesAndReg || 0)}
              </h3>
            </div>
          </div>

          {/* Pending / Upcoming Cards */}
          <div className="acc-pending-row">
            <div className="acc-pending-card acc-pending-blue">
              <p className="acc-pending-label">Pending Payments</p>
              <h3 className="acc-pending-value">
                <span className="acc-stat-tile-currency">{customer_currency}</span>
                {formatNumber(AccountantDataCount.invoiceFeeSumpendingdues || 0)}
              </h3>
              <p className="acc-pending-sub">
                {AccountantDataCount.pending_invoice_count ?? AccountantDataCount.invoice_count ?? 0} Invoices
              </p>
              <a href="/PendingInvoices" className="acc-pending-link">
                View
              </a>
            </div>

            <div className="acc-pending-card acc-pending-teal">
              <p className="acc-pending-label">Pending Fee Dues</p>
              <h3 className="acc-pending-value">
                <span className="acc-stat-tile-currency">{customer_currency}</span>
                {formatNumber(AccountantDataCount.invoiceSumpending || 0)}
              </h3>
              <p className="acc-pending-sub">Fee Dues</p>
              <a href="/PendingInvoices" className="acc-pending-link">
                View
              </a>
            </div>

            <div className="acc-pending-card acc-pending-pink">
              <p className="acc-pending-label">Upcoming Fee</p>
              <h3 className="acc-pending-value">
                <span className="acc-stat-tile-currency">{customer_currency}</span>
                {formatNumber(AccountantDataCount.upcoming_fee_sum || 0)}
              </h3>
              <p className="acc-pending-sub">Fee Dues</p>
              <a href="/UpcomingInvoices" className="acc-pending-link">
                View
              </a>
            </div>
          </div>

          {/* Student Selector */}
          <div className="acc-student-selector">
            <div className="acc-student-selector-icon">
              <FaUser />
            </div>
            <select
              id="acc-student-select"
              className="acc-student-selector-input"
              name="student"
              value={selectedStudentId}
              onChange={handleSelect}
            >
              <option value="">Select Student</option>
              {AccountantStudentList.map((std) => (
                <option key={std.student_id} value={std.student_id}>
                  {std.student_name}
                </option>
              ))}
            </select>
            <button
              className="acc-student-clear-btn"
              onClick={() => {
                setSelectedStudentId("");
                setAccountantData(null);
              }}
            >
              CLEAR
            </button>
          </div>

          {/* Student Detail — only this section shows loader on student change */}
          <div>
            {isStudentLoading ? (
              <div className="acc-student-loader">
                <ScaleLoader color="#F4BB44" />
                <p className="text-muted mt-2">Loading student details...</p>
              </div>
            ) : (
              AccountantData && (
                <StudentDetail data={AccountantData} currency={customer_currency} />
              )
            )}
          </div>
        </div>
      )}
    </div>
  );
}

const StudentDetail = ({ data, currency }) => {
  // Safe extraction with optional chaining
  const student = data?.student_data?.[0] || {};
  const attendance = data?.student_attendance?.[0] || {};
  const wallet = data?.wallet?.[0] || { wallet_amount: 0 };
  const fees = data?.student_fee || [];
  const recharges = data?.wallet_recharge || [];

  // Format numbers with thousand separators (1,234,567)
  const formatNumber = (val) => {
    const num = parseFloat(val);
    if (isNaN(num)) return val ?? 0;
    return num.toLocaleString("en-US", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    });
  };

  const baseUrl = "https://stage.edsys.in/";
  const profileImage =
    student.student_profilepicture &&
    student.student_profilepicture !== "null" &&
    student.student_profilepicture !== ""
      ? `${baseUrl}${student.student_profilepicture}`
      : null;

  const initials = (student.student_name || "ST")
    .split(" ")
    .map((p) => p[0])
    .join("")
    .slice(0, 2)
    .toUpperCase();

  // Resolve a friendly invoice status with proper precedence:
  // overpaid > paid > overdue (date-based) > partial > unpaid
  const resolveStatus = (fee) => {
    const total = parseFloat(fee.fee_invoice_amount_total ?? fee.fee_invoice_amount ?? 0) || 0;
    const paid = parseFloat(fee.fee_invoice_total_amount_paid ?? fee.fee_invoice_amount_paid ?? 0) || 0;
    const dueDate = fee.fee_invoice_due_date ? new Date(fee.fee_invoice_due_date) : null;
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    if (paid > total && total > 0) return { label: "Overpaid", cls: "acc-status-overpaid" };
    if (total > 0 && paid >= total) return { label: "Paid", cls: "acc-status-paid" };
    if (dueDate && !isNaN(dueDate.getTime()) && dueDate < today && paid < total)
      return { label: "Overdue", cls: "acc-status-overdue" };
    if (paid > 0 && paid < total) return { label: "Partially Paid", cls: "acc-status-partial" };
    return { label: "Unpaid", cls: "acc-status-unpaid" };
  };

  return (
    <>
      {/* Student Card */}
      <div className="acc-student-card">
        <div className="acc-student-grid">
          {/* Avatar */}
          <div className="acc-student-avatar-wrap">
            <div className="acc-student-name-pill">
              {student.student_name || "N/A"}
            </div>
            <div className="acc-student-avatar">
              {profileImage ? (
                <img
                  src={profileImage}
                  alt="Profile"
                  onError={(e) => {
                    e.target.style.display = "none";
                  }}
                />
              ) : (
                initials
              )}
            </div>
          </div>

          {/* Student Information */}
          <div>
            <div className="acc-section-label">Student Information</div>
            <div className="acc-info-row">
              <div className="acc-info-label">Full Name</div>
              <div className="acc-info-value">{student.student_name || "N/A"}</div>
            </div>
            <div className="acc-info-row">
              <div className="acc-info-label">Current Class</div>
              <div className="acc-info-value">{attendance.student_class || "N/A"}</div>
            </div>
            <div className="acc-info-row">
              <div className="acc-info-label">Home Address</div>
              <div className="acc-info-value">{attendance.student_address || "N/A"}</div>
            </div>
          </div>

          {/* Financial Status */}
          <div>
            <div className="acc-section-label">Financial Status</div>
            <div className="acc-wallet-card">
              <div className="acc-wallet-icon">
                <FaWallet />
              </div>
              <div className="acc-wallet-label">Current Wallet Balance</div>
              <div className="acc-wallet-value">
                {currency} {formatNumber(wallet.wallet_amount || 0)}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Fee Due Details */}
      <div className="acc-fee-section">
        <div className="acc-fee-section-header">
          <div className="acc-section-label" style={{ marginBottom: 0 }}>
            Fee Due Details
          </div>
          {fees.length > 0 && (
            <span className="acc-fee-action-pill">Action Required</span>
          )}
        </div>

        <table className="acc-fee-table">
          <thead>
            <tr>
              <th>#</th>
              <th>Invoice No</th>
              <th>Invoice Amount</th>
              <th>Paid Amount</th>
              <th>Balance</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {fees.length > 0 ? (
              fees.map((fee, index) => {
                const total =
                  parseFloat(fee.fee_invoice_amount_total ?? fee.fee_invoice_amount ?? 0) || 0;
                const paid =
                  parseFloat(fee.fee_invoice_total_amount_paid ?? fee.fee_invoice_amount_paid ?? 0) || 0;
                const balance = total - paid;
                const status = resolveStatus(fee);
                return (
                  <tr key={fee.fee_invoice_id}>
                    <td>{index + 1}</td>
                    <td className="acc-fee-invoice-id">INV-{fee.fee_invoice_id}</td>
                    <td className="acc-fee-amount">{currency} {formatNumber(total)}</td>
                    <td className="acc-fee-amount">{currency} {formatNumber(paid)}</td>
                    <td className="acc-fee-amount">{currency} {formatNumber(balance)}</td>
                    <td>
                      <span className={`acc-status-pill ${status.cls}`}>
                        {status.label}
                      </span>
                    </td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan="6" className="text-muted text-center">
                  No results found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Wallet Recharges */}
      <div className="acc-fee-section">
        <div className="acc-fee-section-header">
          <div className="acc-section-label" style={{ marginBottom: 0 }}>
            Last 5 Wallet Recharges
          </div>
        </div>

        <table className="acc-fee-table">
          <thead>
            <tr>
              <th>#</th>
              <th>Amount</th>
              <th>Date</th>
              <th>Reference</th>
            </tr>
          </thead>
          <tbody>
            {recharges.length > 0 ? (
              recharges.slice(0, 5).map((item, index) => (
                <tr key={item.wallet_recharge_id}>
                  <td>{index + 1}</td>
                  <td className="acc-fee-amount">{currency} {formatNumber(item.wallet_recharge_amount)}</td>
                  <td>{item.wallet_recharge_date || "N/A"}</td>
                  <td>{item.wallet_recharge_reference_no || "N/A"}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="4" className="text-muted text-center">
                  No records
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default Accountant;
